module.exports = __webpack_public_path__ + "media/icons/i-9-locations-407aee4b.png";